import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

import HomeMainContainer from "./HomeMainContainer";
import WhyChooseDaxma from "./WhyChooseDaxma";
import FoldingLogosSection from "./FoldingLogosSection";
import HotArrivals from "./HotArrivals";
import Home3DBanner from "./Home3dbanner";

const HOT_PRODUCT_IDS = [
  "rt14",
  "h5",
  "pt3",
  "ot7",
  "pt10",
  "ot2",
  "h14",
  "rt1"
];

const Home = () => {

  const [hotItems, setHotItems] = useState([]);

  useEffect(() => {
    fetchHotProducts();
  }, []);

  const fetchHotProducts = async () => {

    const { data, error } = await supabase
      .from("products")
      .select(`
        id,
        title,
        description,
        price,
        mrp,
        fit,
        product_sizes(size),
        product_colors(
          id,
          color_code,
          color_name,
          hex,
          stock,
          product_images(image_url)
        )
      `)
      .in("id", HOT_PRODUCT_IDS);

    if (error) {
      console.error(error);
      return;
    }

    const formatted = data.map((p) => ({
      id: p.id,
      title: p.title,
      description: p.description,
      price: p.price,
      mrp: p.mrp,
      fit: p.fit,
      sizes: p.product_sizes?.map((s) => s.size) || [],
      colors:
        p.product_colors?.map((c) => ({
          id: c.color_code,
          name: c.color_name,
          hex: c.hex,
          stock: c.stock,
          images: c.product_images?.map((img) => img.image_url) || [],
        })) || [],
    }));

    // keep order same as HOT_PRODUCT_IDS
    const ordered = HOT_PRODUCT_IDS
      .map(id => formatted.find(p => p.id === id))
      .filter(Boolean);

    setHotItems(ordered);
  };

  return (
    <div className="w-full overflow-x-hidden">

      <HomeMainContainer />

      {/* HOT ARRIVALS */}
      <HotArrivals items={hotItems} />

      <Home3DBanner />

      <WhyChooseDaxma />

    </div>
  );
};

export default Home;